var map = {
	"./1.mp3": [
		10493,
		5819
	],
	"./10.mp3": [
		10494,
		5820
	],
	"./11.mp3": [
		10495,
		5821
	],
	"./12.mp3": [
		10496,
		5822
	],
	"./13.mp3": [
		10497,
		5823
	],
	"./14.mp3": [
		10498,
		5824
	],
	"./15.mp3": [
		10499,
		5825
	],
	"./16.mp3": [
		10500,
		5826
	],
	"./17.mp3": [
		10501,
		5827
	],
	"./18.mp3": [
		10502,
		5828
	],
	"./19.mp3": [
		10503,
		5829
	],
	"./2.mp3": [
		10504,
		5830
	],
	"./20.mp3": [
		10505,
		5831
	],
	"./3.mp3": [
		10506,
		5832
	],
	"./4.mp3": [
		10507,
		5833
	],
	"./5.mp3": [
		10508,
		5834
	],
	"./6.mp3": [
		10509,
		5835
	],
	"./7.mp3": [
		10510,
		5836
	],
	"./8.mp3": [
		10511,
		5837
	],
	"./9.mp3": [
		10512,
		5838
	],
	"./airplane.mp3": [
		10513,
		5839
	],
	"./alligator.mp3": [
		10514,
		5840
	],
	"./ambulance.mp3": [
		10515,
		5841
	],
	"./amphibian.mp3": [
		10516,
		5842
	],
	"./anchor.mp3": [
		10517,
		5843
	],
	"./animal.mp3": [
		10518,
		5844
	],
	"./animals.mp3": [
		10519,
		5845
	],
	"./ant.mp3": [
		10520,
		5846
	],
	"./anteater.mp3": [
		10521,
		5847
	],
	"./antenna.mp3": [
		10522,
		5848
	],
	"./aphids.mp3": [
		10523,
		5849
	],
	"./apple.mp3": [
		10524,
		5850
	],
	"./arctic fox.mp3": [
		10525,
		5851
	],
	"./arctic wolf.mp3": [
		10526,
		5852
	],
	"./astronaut.mp3": [
		10527,
		5853
	],
	"./baby.mp3": [
		10528,
		5854
	],
	"./backbone.mp3": [
		10529,
		5855
	],
	"./ball.mp3": [
		10530,
		5856
	],
	"./balloon.mp3": [
		10531,
		5857
	],
	"./banana.mp3": [
		10532,
		5858
	],
	"./banjo.mp3": [
		10533,
		5859
	],
	"./barn.mp3": [
		10534,
		5860
	],
	"./bat.mp3": [
		10535,
		5861
	],
	"./bathroom.mp3": [
		10536,
		5862
	],
	"./bathtub.mp3": [
		10537,
		5863
	],
	"./bear.mp3": [
		10538,
		5864
	],
	"./beaver.mp3": [
		10539,
		5865
	],
	"./bed.mp3": [
		10540,
		5866
	],
	"./bedroom.mp3": [
		10541,
		5867
	],
	"./bee.mp3": [
		10542,
		5868
	],
	"./beehive.mp3": [
		10543,
		5869
	],
	"./bighorn sheep.mp3": [
		10544,
		5870
	],
	"./bike.mp3": [
		10545,
		5871
	],
	"./bird.mp3": [
		10546,
		5872
	],
	"./black.mp3": [
		10547,
		5873
	],
	"./blue.mp3": [
		10548,
		5874
	],
	"./boat.mp3": [
		10549,
		5875
	],
	"./body.mp3": [
		10550,
		5876
	],
	"./bone.mp3": [
		10551,
		5877
	],
	"./bongos.mp3": [
		10552,
		5878
	],
	"./book.mp3": [
		10553,
		5879
	],
	"./box.mp3": [
		10554,
		5880
	],
	"./boxer.mp3": [
		10555,
		5881
	],
	"./boy.mp3": [
		10556,
		5882
	],
	"./branch.mp3": [
		10557,
		5883
	],
	"./brown.mp3": [
		10558,
		5884
	],
	"./bus.mp3": [
		10559,
		5885
	],
	"./butterfly.mp3": [
		10560,
		5886
	],
	"./cake.mp3": [
		10561,
		5887
	],
	"./camel.mp3": [
		10562,
		5888
	],
	"./car.mp3": [
		10563,
		5889
	],
	"./carrot.mp3": [
		10564,
		5890
	],
	"./cat.mp3": [
		10565,
		5891
	],
	"./caterpillar.mp3": [
		10566,
		5892
	],
	"./cave.mp3": [
		10567,
		5893
	],
	"./cheese.mp3": [
		10568,
		5894
	],
	"./cheetah.mp3": [
		10569,
		5895
	],
	"./cherry.mp3": [
		10570,
		5896
	],
	"./chick.mp3": [
		10571,
		5897
	],
	"./chicken.mp3": [
		10572,
		5898
	],
	"./chipmunk.mp3": [
		10573,
		5899
	],
	"./christmas tree.mp3": [
		10574,
		5900
	],
	"./christmas.mp3": [
		10575,
		5901
	],
	"./circle.mp3": [
		10576,
		5902
	],
	"./clock.mp3": [
		10577,
		5903
	],
	"./cloud.mp3": [
		10578,
		5904
	],
	"./clouds.mp3": [
		10579,
		5905
	],
	"./clown fish.mp3": [
		10580,
		5906
	],
	"./clown.mp3": [
		10581,
		5907
	],
	"./cobra.mp3": [
		10582,
		5908
	],
	"./coconut.mp3": [
		10583,
		5909
	],
	"./collie.mp3": [
		10584,
		5910
	],
	"./computer.mp3": [
		10585,
		5911
	],
	"./cone.mp3": [
		10586,
		5912
	],
	"./cookie.mp3": [
		10587,
		5913
	],
	"./corgi.mp3": [
		10588,
		5914
	],
	"./corner.mp3": [
		10589,
		5915
	],
	"./couch.mp3": [
		10590,
		5916
	],
	"./cow.mp3": [
		10591,
		5917
	],
	"./crab.mp3": [
		10592,
		5918
	],
	"./crocodile.mp3": [
		10593,
		5919
	],
	"./cube.mp3": [
		10594,
		5920
	],
	"./cup.mp3": [
		10595,
		5921
	],
	"./cylinder.mp3": [
		10596,
		5922
	],
	"./cymbal.mp3": [
		10597,
		5923
	],
	"./dalmatian.mp3": [
		10598,
		5924
	],
	"./deer.mp3": [
		10599,
		5925
	],
	"./desert.mp3": [
		10600,
		5926
	],
	"./dinosaur.mp3": [
		10601,
		5927
	],
	"./dog.mp3": [
		10602,
		5928
	],
	"./dolphin.mp3": [
		10603,
		5929
	],
	"./donkey.mp3": [
		10604,
		5930
	],
	"./dragon.mp3": [
		10605,
		5931
	],
	"./dragonfly.mp3": [
		10606,
		5932
	],
	"./dress.mp3": [
		10607,
		5933
	],
	"./drum.mp3": [
		10608,
		5934
	],
	"./duck.mp3": [
		10609,
		5935
	],
	"./duckling.mp3": [
		10610,
		5936
	],
	"./dump truck.mp3": [
		10611,
		5937
	],
	"./eagle.mp3": [
		10612,
		5938
	],
	"./ear.mp3": [
		10613,
		5939
	],
	"./earth.mp3": [
		10614,
		5940
	],
	"./eel.mp3": [
		10615,
		5941
	],
	"./egg.mp3": [
		10616,
		5942
	],
	"./electricity.mp3": [
		10617,
		5943
	],
	"./elephant.mp3": [
		10618,
		5944
	],
	"./envelope.mp3": [
		10619,
		5945
	],
	"./equal.mp3": [
		10620,
		5946
	],
	"./equals.mp3": [
		10621,
		5947
	],
	"./eye.mp3": [
		10622,
		5948
	],
	"./face (libby curran's conflicted copy 2015-01-12).mp3": [
		10623,
		5949
	],
	"./face.mp3": [
		10624,
		5950
	],
	"./fall.mp3": [
		10625,
		5951
	],
	"./fan.mp3": [
		10626,
		5952
	],
	"./farm.mp3": [
		10627,
		5953
	],
	"./farmer.mp3": [
		10628,
		5954
	],
	"./father.mp3": [
		10629,
		5955
	],
	"./fawn.mp3": [
		10630,
		5956
	],
	"./feather.mp3": [
		10631,
		5957
	],
	"./feet.mp3": [
		10632,
		5958
	],
	"./fennec fox.mp3": [
		10633,
		5959
	],
	"./fiddle.mp3": [
		10634,
		5960
	],
	"./fire truck.mp3": [
		10635,
		5961
	],
	"./fire.mp3": [
		10636,
		5962
	],
	"./fish.mp3": [
		10637,
		5963
	],
	"./flamingo.mp3": [
		10638,
		5964
	],
	"./flower.mp3": [
		10639,
		5965
	],
	"./flying fish.mp3": [
		10640,
		5966
	],
	"./foot.mp3": [
		10641,
		5967
	],
	"./forest.mp3": [
		10642,
		5968
	],
	"./fox.mp3": [
		10643,
		5969
	],
	"./fridge.mp3": [
		10644,
		5970
	],
	"./friend.mp3": [
		10645,
		5971
	],
	"./frog.mp3": [
		10646,
		5972
	],
	"./frost.mp3": [
		10647,
		5973
	],
	"./fur.mp3": [
		10648,
		5974
	],
	"./game.mp3": [
		10649,
		5975
	],
	"./garden.mp3": [
		10650,
		5976
	],
	"./gate.mp3": [
		10651,
		5977
	],
	"./gill.mp3": [
		10652,
		5978
	],
	"./gingerbread.mp3": [
		10653,
		5979
	],
	"./giraffe.mp3": [
		10654,
		5980
	],
	"./girl.mp3": [
		10655,
		5981
	],
	"./goal.mp3": [
		10656,
		5982
	],
	"./goat.mp3": [
		10657,
		5983
	],
	"./goldfish.mp3": [
		10658,
		5984
	],
	"./goose.mp3": [
		10659,
		5985
	],
	"./gorilla.mp3": [
		10660,
		5986
	],
	"./grape.mp3": [
		10661,
		5987
	],
	"./grass.mp3": [
		10662,
		5988
	],
	"./grasshopper.mp3": [
		10663,
		5989
	],
	"./grasslands.mp3": [
		10664,
		5990
	],
	"./gray.mp3": [
		10665,
		5991
	],
	"./green.mp3": [
		10666,
		5992
	],
	"./guitar.mp3": [
		10667,
		5993
	],
	"./hammer.mp3": [
		10668,
		5994
	],
	"./hammerhead shark.mp3": [
		10669,
		5995
	],
	"./hand.mp3": [
		10670,
		5996
	],
	"./harp.mp3": [
		10671,
		5997
	],
	"./hat.mp3": [
		10672,
		5998
	],
	"./hay.mp3": [
		10673,
		5999
	],
	"./head.mp3": [
		10674,
		6000
	],
	"./heart.mp3": [
		10675,
		6001
	],
	"./hedgehog.mp3": [
		10676,
		6002
	],
	"./helicopter.mp3": [
		10677,
		6003
	],
	"./helmet.mp3": [
		10678,
		6004
	],
	"./hermit crab.mp3": [
		10679,
		6005
	],
	"./hexagon.mp3": [
		10680,
		6006
	],
	"./hippo.mp3": [
		10681,
		6007
	],
	"./home.mp3": [
		10682,
		6008
	],
	"./hoof.mp3": [
		10683,
		6009
	],
	"./horn.mp3": [
		10684,
		6010
	],
	"./horse.mp3": [
		10685,
		6011
	],
	"./hot-air balloon.mp3": [
		10686,
		6012
	],
	"./house.mp3": [
		10687,
		6013
	],
	"./hummingbird.mp3": [
		10688,
		6014
	],
	"./hump.mp3": [
		10689,
		6015
	],
	"./ice cream.mp3": [
		10690,
		6016
	],
	"./ice skates.mp3": [
		10691,
		6017
	],
	"./ice.mp3": [
		10692,
		6018
	],
	"./iceberg.mp3": [
		10693,
		6019
	],
	"./igloo.mp3": [
		10694,
		6020
	],
	"./iguana.mp3": [
		10695,
		6021
	],
	"./ink.mp3": [
		10696,
		6022
	],
	"./insect.mp3": [
		10697,
		6023
	],
	"./island.mp3": [
		10698,
		6024
	],
	"./jack-in-the-box.mp3": [
		10699,
		6025
	],
	"./jacket.mp3": [
		10700,
		6026
	],
	"./jaguar.mp3": [
		10701,
		6027
	],
	"./jar.mp3": [
		10702,
		6028
	],
	"./jeep.mp3": [
		10703,
		6029
	],
	"./jellyfish.mp3": [
		10704,
		6030
	],
	"./juggler.mp3": [
		10705,
		6031
	],
	"./kangaroo.mp3": [
		10706,
		6032
	],
	"./kangaroos.mp3": [
		10707,
		6033
	],
	"./key.mp3": [
		10708,
		6034
	],
	"./kid.mp3": [
		10709,
		6035
	],
	"./king.mp3": [
		10710,
		6036
	],
	"./kitchen.mp3": [
		10711,
		6037
	],
	"./kite.mp3": [
		10712,
		6038
	],
	"./kitten.mp3": [
		10713,
		6039
	],
	"./koala.mp3": [
		10714,
		6040
	],
	"./ladder.mp3": [
		10715,
		6041
	],
	"./ladybug.mp3": [
		10716,
		6042
	],
	"./lake.mp3": [
		10717,
		6043
	],
	"./lamb.mp3": [
		10718,
		6044
	],
	"./land.mp3": [
		10719,
		6045
	],
	"./leaf.mp3": [
		10720,
		6046
	],
	"./leg.mp3": [
		10721,
		6047
	],
	"./lemon.mp3": [
		10722,
		6048
	],
	"./light.mp3": [
		10723,
		6049
	],
	"./lion cub.mp3": [
		10724,
		6050
	],
	"./lion.mp3": [
		10725,
		6051
	],
	"./lioness.mp3": [
		10726,
		6052
	],
	"./liquid.mp3": [
		10727,
		6053
	],
	"./living room.mp3": [
		10728,
		6054
	],
	"./lizard.mp3": [
		10729,
		6055
	],
	"./lobster.mp3": [
		10730,
		6056
	],
	"./log.mp3": [
		10731,
		6057
	],
	"./lollipop.mp3": [
		10732,
		6058
	],
	"./long neck dinosaur.mp3": [
		10733,
		6059
	],
	"./lungs.mp3": [
		10734,
		6060
	],
	"./magnet.mp3": [
		10735,
		6061
	],
	"./mammal.mp3": [
		10736,
		6062
	],
	"./man.mp3": [
		10737,
		6063
	],
	"./map.mp3": [
		10738,
		6064
	],
	"./mars.mp3": [
		10739,
		6065
	],
	"./meat.mp3": [
		10740,
		6066
	],
	"./milk.mp3": [
		10741,
		6067
	],
	"./mitten.mp3": [
		10742,
		6068
	],
	"./monkey.mp3": [
		10743,
		6069
	],
	"./monster.mp3": [
		10744,
		6070
	],
	"./moon.mp3": [
		10745,
		6071
	],
	"./moose.mp3": [
		10746,
		6072
	],
	"./mother.mp3": [
		10747,
		6073
	],
	"./motorcycle.mp3": [
		10748,
		6074
	],
	"./mountain.mp3": [
		10749,
		6075
	],
	"./mouse.mp3": [
		10750,
		6076
	],
	"./mouth.mp3": [
		10751,
		6077
	],
	"./music.mp3": [
		10752,
		6078
	],
	"./nail.mp3": [
		10753,
		6079
	],
	"./neck.mp3": [
		10754,
		6080
	],
	"./necklace.mp3": [
		10755,
		6081
	],
	"./nest.mp3": [
		10756,
		6082
	],
	"./net.mp3": [
		10757,
		6083
	],
	"./night.mp3": [
		10758,
		6084
	],
	"./nose.mp3": [
		10759,
		6085
	],
	"./nut.mp3": [
		10760,
		6086
	],
	"./ocean.mp3": [
		10761,
		6087
	],
	"./octagon.mp3": [
		10762,
		6088
	],
	"./octopus.mp3": [
		10763,
		6089
	],
	"./orange.mp3": [
		10764,
		6090
	],
	"./oranges.mp3": [
		10765,
		6091
	],
	"./orangutan.mp3": [
		10766,
		6092
	],
	"./ostrich.mp3": [
		10767,
		6093
	],
	"./otter.mp3": [
		10768,
		6094
	],
	"./owl.mp3": [
		10769,
		6095
	],
	"./ox.mp3": [
		10770,
		6096
	],
	"./paint.mp3": [
		10771,
		6097
	],
	"./panda.mp3": [
		10772,
		6098
	],
	"./parachute.mp3": [
		10773,
		6099
	],
	"./parrot.mp3": [
		10774,
		6100
	],
	"./party.mp3": [
		10775,
		6101
	],
	"./peacock.mp3": [
		10776,
		6102
	],
	"./pelican.mp3": [
		10777,
		6103
	],
	"./penguin.mp3": [
		10778,
		6104
	],
	"./pentagon.mp3": [
		10779,
		6105
	],
	"./pet.mp3": [
		10780,
		6106
	],
	"./piano.mp3": [
		10781,
		6107
	],
	"./pig.mp3": [
		10782,
		6108
	],
	"./piglet.mp3": [
		10783,
		6109
	],
	"./pink.mp3": [
		10784,
		6110
	],
	"./pirate.mp3": [
		10785,
		6111
	],
	"./plane.mp3": [
		10786,
		6112
	],
	"./planet.mp3": [
		10787,
		6113
	],
	"./plant.mp3": [
		10788,
		6114
	],
	"./playground.mp3": [
		10789,
		6115
	],
	"./polar bear cub.mp3": [
		10790,
		6116
	],
	"./polar bear.mp3": [
		10791,
		6117
	],
	"./pond.mp3": [
		10792,
		6118
	],
	"./poodle.mp3": [
		10793,
		6119
	],
	"./praying mantis.mp3": [
		10794,
		6120
	],
	"./present.mp3": [
		10795,
		6121
	],
	"./ptarmigan.mp3": [
		10796,
		6122
	],
	"./pterosaur.mp3": [
		10797,
		6123
	],
	"./pulley.mp3": [
		10798,
		6124
	],
	"./pumpkin.mp3": [
		10799,
		6125
	],
	"./puppy.mp3": [
		10800,
		6126
	],
	"./purple.mp3": [
		10801,
		6127
	],
	"./pyramid.mp3": [
		10802,
		6128
	],
	"./quarter.mp3": [
		10803,
		6129
	],
	"./quarters.mp3": [
		10804,
		6130
	],
	"./queen.mp3": [
		10805,
		6131
	],
	"./question mark.mp3": [
		10806,
		6132
	],
	"./quilt.mp3": [
		10807,
		6133
	],
	"./quotation marks.mp3": [
		10808,
		6134
	],
	"./rabbit.mp3": [
		10809,
		6135
	],
	"./raccoon.mp3": [
		10810,
		6136
	],
	"./race.mp3": [
		10811,
		6137
	],
	"./rain.mp3": [
		10812,
		6138
	],
	"./rainbow.mp3": [
		10813,
		6139
	],
	"./rainforest.mp3": [
		10814,
		6140
	],
	"./raptor.mp3": [
		10815,
		6141
	],
	"./rat.mp3": [
		10816,
		6142
	],
	"./rectangle.mp3": [
		10817,
		6143
	],
	"./rectangular prism.mp3": [
		10818,
		6144
	],
	"./red.mp3": [
		10819,
		6145
	],
	"./reindeer.mp3": [
		10820,
		6146
	],
	"./reptile.mp3": [
		10821,
		6147
	],
	"./rhino.mp3": [
		10822,
		6148
	],
	"./river.mp3": [
		10823,
		6149
	],
	"./road.mp3": [
		10824,
		6150
	],
	"./robot.mp3": [
		10825,
		6151
	],
	"./rock.mp3": [
		10826,
		6152
	],
	"./rocket.mp3": [
		10827,
		6153
	],
	"./room.mp3": [
		10828,
		6154
	],
	"./rooster.mp3": [
		10829,
		6155
	],
	"./roots.mp3": [
		10830,
		6156
	],
	"./salamander.mp3": [
		10831,
		6157
	],
	"./sandcastle.mp3": [
		10832,
		6158
	],
	"./santa.mp3": [
		10833,
		6159
	],
	"./satellite.mp3": [
		10834,
		6160
	],
	"./saturn.mp3": [
		10835,
		6161
	],
	"./saxophone.mp3": [
		10836,
		6162
	],
	"./scarf.mp3": [
		10837,
		6163
	],
	"./scuba diver.mp3": [
		10838,
		6164
	],
	"./sea snake.mp3": [
		10839,
		6165
	],
	"./sea turtle.mp3": [
		10840,
		6166
	],
	"./sea.mp3": [
		10841,
		6167
	],
	"./seagull.mp3": [
		10842,
		6168
	],
	"./seahorse.mp3": [
		10843,
		6169
	],
	"./seal pup.mp3": [
		10844,
		6170
	],
	"./seal.mp3": [
		10845,
		6171
	],
	"./seeds.mp3": [
		10846,
		6172
	],
	"./seesaw.mp3": [
		10847,
		6173
	],
	"./shark.mp3": [
		10848,
		6174
	],
	"./sheep.mp3": [
		10849,
		6175
	],
	"./shell.mp3": [
		10850,
		6176
	],
	"./shirt.mp3": [
		10851,
		6177
	],
	"./shower.mp3": [
		10852,
		6178
	],
	"./shrimp.mp3": [
		10853,
		6179
	],
	"./skates.mp3": [
		10854,
		6180
	],
	"./skunk.mp3": [
		10855,
		6181
	],
	"./sky.mp3": [
		10856,
		6182
	],
	"./sleigh.mp3": [
		10857,
		6183
	],
	"./slide.mp3": [
		10858,
		6184
	],
	"./slug.mp3": [
		10859,
		6185
	],
	"./snail.mp3": [
		10860,
		6186
	],
	"./snake.mp3": [
		10861,
		6187
	],
	"./snow.mp3": [
		10862,
		6188
	],
	"./snowball.mp3": [
		10863,
		6189
	],
	"./snowman.mp3": [
		10864,
		6190
	],
	"./snowshoe rabbit.mp3": [
		10865,
		6191
	],
	"./snowy owl.mp3": [
		10866,
		6192
	],
	"./soccer.mp3": [
		10867,
		6193
	],
	"./sock.mp3": [
		10868,
		6194
	],
	"./soil.mp3": [
		10869,
		6195
	],
	"./solid.mp3": [
		10870,
		6196
	],
	"./space.mp3": [
		10871,
		6197
	],
	"./spaceship.mp3": [
		10872,
		6198
	],
	"./sphere.mp3": [
		10873,
		6199
	],
	"./spider.mp3": [
		10874,
		6200
	],
	"./spring.mp3": [
		10875,
		6201
	],
	"./square.mp3": [
		10876,
		6202
	],
	"./squid.mp3": [
		10877,
		6203
	],
	"./squirrel.mp3": [
		10878,
		6204
	],
	"./star.mp3": [
		10879,
		6205
	],
	"./starfish.mp3": [
		10880,
		6206
	],
	"./stegosaurus.mp3": [
		10881,
		6207
	],
	"./stem.mp3": [
		10882,
		6208
	],
	"./stocking.mp3": [
		10883,
		6209
	],
	"./stove.mp3": [
		10884,
		6210
	],
	"./summer.mp3": [
		10885,
		6211
	],
	"./sun.mp3": [
		10886,
		6212
	],
	"./sunflower.mp3": [
		10887,
		6213
	],
	"./swimming dinosaur.mp3": [
		10888,
		6214
	],
	"./swing.mp3": [
		10889,
		6215
	],
	"./swordfish.mp3": [
		10890,
		6216
	],
	"./t. rex.mp3": [
		10891,
		6217
	],
	"./table.mp3": [
		10892,
		6218
	],
	"./tail.mp3": [
		10893,
		6219
	],
	"./tambourine.mp3": [
		10894,
		6220
	],
	"./tank.mp3": [
		10895,
		6221
	],
	"./television.mp3": [
		10896,
		6222
	],
	"./tiger.mp3": [
		10897,
		6223
	],
	"./toad.mp3": [
		10898,
		6224
	],
	"./tooth.mp3": [
		10899,
		6225
	],
	"./toucan.mp3": [
		10900,
		6226
	],
	"./toys.mp3": [
		10901,
		6227
	],
	"./tractor.mp3": [
		10902,
		6228
	],
	"./train.mp3": [
		10903,
		6229
	],
	"./tree.mp3": [
		10904,
		6230
	],
	"./triangle.mp3": [
		10905,
		6231
	],
	"./triceratops.mp3": [
		10906,
		6232
	],
	"./truck.mp3": [
		10907,
		6233
	],
	"./turtle.mp3": [
		10908,
		6234
	],
	"./tusk.mp3": [
		10909,
		6235
	],
	"./umbrella.mp3": [
		10910,
		6236
	],
	"./underwear.mp3": [
		10911,
		6237
	],
	"./unicorn.mp3": [
		10912,
		6238
	],
	"./unicycle.mp3": [
		10913,
		6239
	],
	"./vampire.mp3": [
		10914,
		6240
	],
	"./van.mp3": [
		10915,
		6241
	],
	"./vehicle.mp3": [
		10916,
		6242
	],
	"./violin.mp3": [
		10917,
		6243
	],
	"./volcano.mp3": [
		10918,
		6244
	],
	"./wagon.mp3": [
		10919,
		6245
	],
	"./walrus.mp3": [
		10920,
		6246
	],
	"./water.mp3": [
		10921,
		6247
	],
	"./weather.mp3": [
		10922,
		6248
	],
	"./whale shark.mp3": [
		10923,
		6249
	],
	"./whale.mp3": [
		10924,
		6250
	],
	"./wheel.mp3": [
		10925,
		6251
	],
	"./wheelchair.mp3": [
		10926,
		6252
	],
	"./white.mp3": [
		10927,
		6253
	],
	"./wild.mp3": [
		10928,
		6254
	],
	"./wind.mp3": [
		10929,
		6255
	],
	"./wing.mp3": [
		10930,
		6256
	],
	"./winter.mp3": [
		10931,
		6257
	],
	"./witch.mp3": [
		10932,
		6258
	],
	"./wolf cub.mp3": [
		10933,
		6259
	],
	"./wolf.mp3": [
		10934,
		6260
	],
	"./woman.mp3": [
		10935,
		6261
	],
	"./worm.mp3": [
		10936,
		6262
	],
	"./x-ray.mp3": [
		10937,
		6263
	],
	"./xylophone.mp3": [
		10938,
		6264
	],
	"./yak.mp3": [
		10939,
		6265
	],
	"./yellow.mp3": [
		10940,
		6266
	],
	"./yoyo.mp3": [
		10941,
		6267
	],
	"./zebra.mp3": [
		10942,
		6268
	],
	"./zero.mp3": [
		10943,
		6269
	],
	"./zipper.mp3": [
		10944,
		6270
	],
	"./zoo.mp3": [
		10945,
		6271
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 7185;
module.exports = webpackAsyncContext;